import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/tipo_atendimentos${queryUrl}`)
  },
  insertNewTipoAtendimento(data) {
    return axios.post('/atendimento/tipo_atendimentos', data)
  },
  editTipoAtendimento(data) {
    return axios.put(`/atendimento/tipo_atendimentos/${data.id}`, data)
  },
  deleteTipoAtendimento(id) {
    return axios.delete(`/atendimento/tipo_atendimentos/${id}`)
  },
}
